import { render, staticRenderFns } from "./OtherSales.vue?vue&type=template&id=756c6410"
import script from "./OtherSales.vue?vue&type=script&lang=js"
export * from "./OtherSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports